export interface ITelemetryData {
    correlationId: string;
    portal: string;
    culture: string;
    searchTerm: string;
    shortLink: string;
    suggestion: string;
    contentType: TelemetryContentEnum;
}

export enum TelemetryContentEnum {
    Articles = "Articles",
    Content = "content",
    FlexibleSet = "FlexibleSet",
    FeaturePromotion = "FeaturePromotion",
    ShowAllResults = "ShowAllResults",
    TopSearchQuery = "TopSearchQuery"
}
